import type { Product } from '@forest/native-services'
import type { Platform } from '~/params'
import type { ChinaAndroidTrialEligibility } from '~/store'

/**
 * china_android trials are granted by the receipt system (checked at setup),
 * not by trial days on the store product like the other platforms.
 */
export function getTrialEligibility(
  platform: Platform,
  chinaAndroidTrialEligibility: ChinaAndroidTrialEligibility,
  product: Pick<Product, 'eligible_trial_days'> | undefined,
) {
  const isChinaAndroidTrial =
    platform === 'china_android' && chinaAndroidTrialEligibility === 'available'
  return {
    isChinaAndroidTrial,
    isTrial: isChinaAndroidTrial || (product?.eligible_trial_days ?? 0) > 0,
  }
}
